// import { useFieldArray } from 'react-hook-form';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Accordion, AccordionTab } from 'primereact/accordion';
import ProductItem from './ProductItem';

export default function Products({ disabled, control, errors, data }) {
  // #region Data
  const { t } = useTranslation();
  // fields
  //   const { fields, append, remove } = useFieldArray({
  //     control,
  //     name: 'listProducts',
  //   });

  // handleCustomCheck
  //   const handleCustomCheck = (key) => {
  //     const field = fields.find((e) => e.key === key);
  //     if (field) {
  //       const index = fields.indexOf(field);
  //       remove(index);
  //     } else {
  //       append({ key });
  //     }
  //   };

  const leftKeys = {
    summaryReportQuantity: t('r09.form.finalReport'),
    branchProposalReportQuantity: t('r09.form.reportBranchTopic'),
    thematicReportQuantity: t('r09.form.reportThematic'),
    mapQuantity: t('r09.form.map'),
    filmQuantity: t('r09.form.film'),
  };

  const rightKeys = {
    videoQuantity: t('r09.form.videoTape'),
    imageQuantity: t('r09.form.picture'),
    cdDiskQuantity: t('r09.form.cd'),
    documentQuantity: t('r09.form.document'),
    other: t('r09.form.other'),
  };

  // #endregion Data
  return (
    <div className="ml-2">
      <div className="grid">
        {/* left */}
        <div className="col-6">
          {disabled ? (
            <>
              {' '}
              {leftKeys &&
                Object.keys(leftKeys).map((key) => (
                  <ProductItem
                    control={control}
                    errors={errors}
                    name={key}
                    viewOnly
                    value={{
                      header: leftKeys[key],
                      detail: data?.[key] || '',
                    }}
                  />
                ))}
            </>
          ) : (
            <Accordion activeIndex={[0]} multiple>
              <AccordionTab header={t('r09.form.finalReport')}>
                <ProductItem control={control} errors={errors} name="summaryReportQuantity" />
              </AccordionTab>
              <AccordionTab header={t('r09.form.reportBranchTopic')}>
                <ProductItem
                  control={control}
                  errors={errors}
                  name="branchProposalReportQuantity"
                />
              </AccordionTab>
              <AccordionTab header={t('r09.form.reportThematic')}>
                <ProductItem control={control} errors={errors} name="thematicReportQuantity" />
              </AccordionTab>
              <AccordionTab header={t('r09.form.map')}>
                <ProductItem control={control} errors={errors} name="mapQuantity" />
              </AccordionTab>
              <AccordionTab header={t('r09.form.film')}>
                <ProductItem control={control} errors={errors} name="filmQuantity" />
              </AccordionTab>
            </Accordion>
          )}
        </div>

        {/* right */}
        <div className="col-6">
          {disabled ? (
            <>
              {' '}
              {rightKeys &&
                Object.keys(rightKeys).map((key) => (
                  <ProductItem
                    control={control}
                    errors={errors}
                    name={key}
                    viewOnly
                    value={{
                      header: rightKeys[key],
                      detail: data?.[key] || '',
                    }}
                  />
                ))}
            </>
          ) : (
            <Accordion activeIndex={[0]} multiple>
              <AccordionTab header={t('r09.form.videoTape')}>
                <ProductItem control={control} errors={errors} name="videoQuantity" />
              </AccordionTab>
              <AccordionTab header={t('r09.form.picture')}>
                <ProductItem control={control} errors={errors} name="imageQuantity" />
              </AccordionTab>
              <AccordionTab header={t('r09.form.cd')}>
                <ProductItem control={control} errors={errors} name="cdDiskQuantity" />
              </AccordionTab>
              <AccordionTab header={t('r09.form.document')}>
                <ProductItem control={control} errors={errors} name="documentQuantity" />
              </AccordionTab>
              <AccordionTab header={t('r09.form.other')}>
                <ProductItem control={control} errors={errors} name="other" disabled={disabled} />
              </AccordionTab>
            </Accordion>
          )}
        </div>
      </div>
    </div>
  );
}

Products.propTypes = {
  disabled: PropTypes.bool,
  errors: PropTypes.shape({}).isRequired,
  control: PropTypes.shape({}).isRequired,
  // eslint-disable-next-line react/forbid-prop-types, react/require-default-props
  data: PropTypes.object,
};

Products.defaultProps = {
  disabled: false,
  data: {},
};
